import React from "react";
import SelfCalendarHandler from "./SelfCalendarHandler";

const SelfCalendar = ({ userData }) => {
  return (
    <div>
      <main className="">
        <div className="">
          <div className="">
            <div
              className="rounded-lg shadow"
              style={{ height: "81vh", overflow: "scroll" }}
            >
              <SelfCalendarHandler patientsData={userData} />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SelfCalendar;
